import R from 'ramda';

export const apiResponse = R.propOr(null, 'fields');
